import { render, staticRenderFns } from "./ProductSingleTierPrice.vue?vue&type=template&id=61425230&"
import script from "./ProductSingleTierPrice.vue?vue&type=script&lang=js&"
export * from "./ProductSingleTierPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports